module.exports = __webpack_public_path__ + "img/AF_GusmãoLabrunie_Icones_copyright.c580d673.png";